import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const EnvelopeIcon16 = (props: SvgProps) => (
  <Svg
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <Path
      fill="#8AB2D9"
      d="M1 5.78v5.72a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5.78L9.048 9.441a2 2 0 0 1-2.096 0L1 5.779Z"
    />
    <Path
      fill="#8AB2D9"
      d="M15 4.605V4.5a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v.105L7.476 8.59a1 1 0 0 0 1.048 0L15 4.605Z"
    />
  </Svg>
);
export default EnvelopeIcon16;
